import initStickyContent from './sticky-content';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-anw-sticky-content]').forEach((element: Element) => {
    initStickyContent(<HTMLElement>element);
  });
});
